export default function Services() {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: '제품 기획 & 개발',
      description: '시장 트렌드 분석부터 제품 컨셉 개발까지, 브랜드의 비전을 현실로 만듭니다.'
    },
    {
      icon: 'ri-flask-line',
      title: 'OEM/ODM 생산',
      description: '최신 설비와 전문 인력을 통해 고품질 화장품을 안정적으로 생산합니다.'
    },
    {
      icon: 'ri-shield-check-line',
      title: '품질 관리 & 인증',
      description: 'ISO 인증 시스템과 엄격한 품질 검사로 제품의 안전성을 보장합니다.'
    },
    {
      icon: 'ri-truck-line',
      title: '물류 & 납품',
      description: '효율적인 물류 시스템으로 정확한 시간에 완벽한 상태로 제품을 전달합니다.'
    }
  ];

  return (
    <section id="services" className="py-24 lg:py-32 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-4">
            OUR SERVICES
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            브랜드 성공을 위한 통합 솔루션을 제공합니다
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group p-8 lg:p-10 bg-gray-800 border border-amber-700/30 rounded-2xl hover:bg-gradient-to-br hover:from-amber-700/20 hover:to-amber-900/20 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-700/10 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-amber-600 group-hover:text-amber-500 transition-colors`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4 group-hover:text-amber-400 transition-colors">
                {service.title}
              </h3>
              
              <p className="text-base text-gray-400 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
